// Manages the single JSON-LD script injected for the active route.
// Kept separate from runtime meta-tag mutation so schema handling stays isolated.
export function applySchema(id: string, jsonLd?: object) {
  const existing = document.getElementById(id) as HTMLScriptElement | null;
  if (!jsonLd) {
    existing?.remove();
    return;
  }
  let script = existing;
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.setAttribute('type', 'application/ld+json');
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(jsonLd);
}